// import ReactGA from 'react-ga4';
// // import { measurementId } from '../api/http';
// import {measurementId} from '../src/api/http'

// const id = measurementId;
// export const initGA = () => {
//   console.log('GA init with id:', id);
//   ReactGA.initialize(id);
// };

// export const logEvent = (category, action, label) => {
//   ReactGA.event({
//     category,
//     action,
//     label,
//   });
// };

// export const logPageView = (page) => {
//   ReactGA.send({ hitType: 'pageview', page });
// };


import ReactGA from "react-ga4";

// Use environment variable instead of hardcoding
const GA_MEASUREMENT_ID = process.env.REACT_APP_MEASUREMENT_ID;

export const initGA = () => {
  if (!GA_MEASUREMENT_ID) {
    console.warn("GA Measurement ID is not defined!");
    return;
  }
  console.log("GA initialized with ID:", GA_MEASUREMENT_ID);
  ReactGA.initialize(GA_MEASUREMENT_ID);
};

export const logEvent = (category, action, label) => {
  if (!GA_MEASUREMENT_ID) return;
  ReactGA.event({
    category,
    action,
    label,
  });
};

export const logPageView = (page) => {
  if (!GA_MEASUREMENT_ID) return;
  ReactGA.send({ hitType: "pageview", page });
};
